import { render, staticRenderFns } from "./LicensePlateInput.vue?vue&type=template&id=4ac031ec"
import script from "./LicensePlateInput.vue?vue&type=script&lang=js"
export * from "./LicensePlateInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports